import { postAction } from './postAction'

export async function rebuildConfigCache(
  token: string,
  tenantGroupCode: string | null,
): Promise<string> {
  const body = tenantGroupCode ? { tenantGroupCode } : undefined
  const result = await postAction('/v1/act/build/config', token, body)
  return result.message ?? 'Config cache rebuild request accepted.'
}
